import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import {
  assignInquiryToUser,
  createFlightInquiry,
  createHotelInquiry,
  createPackageInquiry,
  createVisaInquiry,
  deleteInquiry,
  getAllInquiries,
  getFlightInquiryByID,
  getFollowupsByInquiryID,
  getHotelInquiryByID,
  getInquiryAssignUserHistory,
  getInquiryByID,
  getPackageInquiryByID,
  getVisaInquiryByID,
  insertFollowUp,
  updateFlightInquiry,
  updateFollowUpStatus,
  updateHotelInquiry,
  updateInquiryStageStatus,
  updateInquiryStatus,
  updatePackageInquiry,
  updateVisaInquiry,
} from "./services/inquiry.services";
import { IInquiryInitialState } from "./inquiryModel";
import { getLocalStorageData } from "../../_helper/helper";

const UserTypeIDString = getLocalStorageData("UserTypeID");
const UserTypeID = UserTypeIDString ? parseInt(UserTypeIDString) : 0;

const initialState: IInquiryInitialState = {
  loading: false,
  completeFollowupOpen: false,
  formLoading: false,
  error: "",
  activeTabIndex: 0,
  InquiryList: [],
  InquiryFollowupList: [],
  InquiryAssignUserHistory: [],
  InquiryID: null,
  TripID: null,
  InquiryStageID: null,
  InquiryStageDetails: {
    InquiryStageID: null,
    LostReasonID: null,
  },
  InquiryType: "",
  InquiryStageCounts: {
    OverallLeads: null,
    TotalInProgress: null,
    TotalConfirmed: null,
    TotalRejected: null,
    TotalcallBack: null,
    TotalUnassigned: null,
    TotalRecentInquiries: null,
    TotalNew: null,
  },
  InquiryDetails: {
    QueryType: "FIT(Normal)",
    TripType: "One Way",
    Child: "zero",
    Infant: "zero",
  },
  InquiryPackageDetails: {
    ID: null,
    ContactID: null,
    LeadID: null,
    RequirementType: "PACKAGE",
    Initial: "",
    FirstName: "",
    LastName: "",
    EmailID: "",
    MobileNo: "",
    // GoingfromID: null,
    Goingfrom: "",
    DestinationID: null,
    FoodPreferenceID: null,
    NoOfPax: null,
    NoOfNights: null,
    InquirySourceID: null,
    Budget: null,
    ExpClosureDate: "",
    ExpClosureAmount: null,
    TravelDate: "",
    HotelPreference: "",
    QueryType: "FIT(Normal)",
    Remarks: "",
  },
  InquiryFlightDetails: {
    ID: null,
    ContactID: null,
    LeadID: null,
    Initial: "",
    FirstName: "",
    LastName: "",
    EmailID: "",
    MobileNo: "",
    TripType: "One Way",
    FromPlaceID: null,
    ToPlaceID: null,
    DepartureDate: "",
    ReturnDate: "",
    Adult: null,
    Child: null,
    Infant: null,
    FlightClassID: null,
    PreferredAirlineID: "",
    InquirySourceID: null,
    Remarks: "",
    RequirementType: "FLIGHT",
    ExpClosureDate: "",
    ExpClosureAmount: null,
  },
  InquiryVisaDetails: {
    ID: null,
    ContactID: null,
    LeadID: null,
    Initial: "",
    FirstName: "",
    LastName: "",
    EmailID: "",
    MobileNo: "",
    InquirySourceID: null,
    RequirementType: "VISA",
    InquirySource: "",
    CountryID: null,
    VisaCategoryID: null,
    EntryType: "",
    EntryTypeID: null,
    DateofTravel: "",
    Adult: null,
    Child: null,
    Infant: null,
    Duration: null,
    NationalityID: null,
    Remarks: "",
  },
  InquiryHotelDetails: {
    ID: null,
    ContactID: null,
    LeadID: null,
    Initial: "",
    FirstName: "",
    LastName: "",
    EmailID: "",
    MobileNo: "",
    InquirySourceID: null,
    RequirementType: "HOTEL",
    InquirySource: "",
    NationalityID: null,
    Remarks: "",
    CityID: null,
    DestinationName: "",
    CheckIn: "",
    CheckOut: "",
    NoOfNights: null,
    Travelers: null,
    StarRating: 0,
    MealTypeID: null,
    HotelRooms: [],
  },
  InquiryFilterDetails: {
    filterIsNew: UserTypeID > 2 ? true : false,
    filterNoOfNights: 0,
    filterContactID: "",
    filterLeadID: "",
    filterInquirySourceID: null,
    filterCity: null,
    filterDestination: null,
    filterGoingfrom: "",
    filterTypeofInquiry: "",
    filterRequirementType: "",
    filterName: "",
    filterMobileNo: "",
    filterEmailID: "",
    filterAssignedTo: null,
    filterUnassignedLeads: false,
    filterFromDate: "",
    filterToDate: "",
    filterAdName: "",
    filterFromBudget: 0,
    filterToBudget: 0,
    filterIsRecent: false,
    Budget: {
      start: 0,
      end: 10000,
    },
    filterInquiryStageID: null,
  },
};

const inquirySlice = createSlice({
  name: "inquiry",
  initialState,
  reducers: {
    clearInquiryDetails: (state) => {
      state.InquiryPackageDetails = initialState.InquiryPackageDetails;
      state.InquiryFlightDetails = initialState.InquiryFlightDetails;
      state.InquiryVisaDetails = initialState.InquiryVisaDetails;
      state.InquiryHotelDetails = initialState.InquiryHotelDetails;
      state.InquiryDetails = initialState.InquiryDetails;
    },
    clearInquiryList: (state) => {
      state.InquiryList = initialState.InquiryList;
    },
    setInquiryID: (state, action) => {
      state.InquiryID = action.payload;
    },
    clearInquiryID: (state) => {
      state.InquiryID = initialState.InquiryID;
    },
    setTripID: (state, action) => {
      state.TripID = action.payload;
    },
    clearTripID: (state) => {
      state.TripID = initialState.TripID;
    },
    setInquiryStageID: (state, action) => {
      state.InquiryStageID = action.payload;
    },
    clearInquiryStageID: (state) => {
      state.InquiryStageID = initialState.InquiryStageID;
    },
    setInquiryStageDetails: (state, action) => {
      state.InquiryStageDetails = action.payload;
    },
    clearInquiryStageDetails: (state) => {
      state.InquiryStageDetails = initialState.InquiryStageDetails;
    },
    setInquiryStatus: (state, action) => {
      state.InquiryType = action.payload;
    },
    clearInquiryStatus: (state) => {
      state.InquiryType = initialState.InquiryType;
    },
    setactiveTabIndex: (state, action) => {
      state.activeTabIndex = action.payload;
    },
    setInquiryFilterDetails: (state, action) => {
      state.InquiryFilterDetails = action.payload;
    },
    clearInquiryFilterDetails: (state) => {
      state.InquiryFilterDetails = initialState.InquiryFilterDetails;
      // state.InquiryFilterDetails = {
      //   ...initialState.InquiryFilterDetails,
      //   filterLeadID: state.InquiryFilterDetails?.filterLeadID,
      //   filterContactID: state.InquiryFilterDetails?.filterContactID,
      // };
    },
    openCompleteFollowupDialog: (state) => {
      state.completeFollowupOpen = true;
    },
    closeCompleteFollowupDialog: (state) => {
      state.completeFollowupOpen = false;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getAllInquiries.pending, (state) => {
      state.loading = true;
      state.error = "";
      state.InquiryList = [];
    });
    builder.addCase(
      getAllInquiries.fulfilled,
      (state, action: PayloadAction<any>) => {
        state.loading = false;
        state.InquiryList = action.payload?.InquiryList || [];
        state.InquiryStageCounts.OverallLeads =
          action.payload.OverallLeads || null;
        state.InquiryStageCounts.TotalInProgress =
          action.payload.TotalInProgress || null;
        state.InquiryStageCounts.TotalConfirmed =
          action.payload.TotalConfirmed || null;
        state.InquiryStageCounts.TotalRejected =
          action.payload.TotalRejected || null;
        state.InquiryStageCounts.TotalcallBack =
          action.payload.TotalcallBack || null;
        state.InquiryStageCounts.TotalUnassigned =
          action.payload.TotalUnassigned || null;
        state.InquiryStageCounts.TotalRecentInquiries =
          action.payload.TotalRecentInquiries || null;
        state.InquiryStageCounts.TotalNew = action.payload.TotalNew || null;
      },
    );
    builder.addCase(getAllInquiries.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
      state.InquiryList = [];
      state.InquiryStageCounts.OverallLeads = null;
      state.InquiryStageCounts.TotalInProgress = null;
      state.InquiryStageCounts.TotalConfirmed = null;
      state.InquiryStageCounts.TotalRejected = null;
      state.InquiryStageCounts.TotalcallBack = null;
      state.InquiryStageCounts.TotalUnassigned = null;
      state.InquiryStageCounts.TotalRecentInquiries = null;
      state.InquiryStageCounts.TotalNew = null;
    });

    // builder.addCase(createInquiry.pending, (state) => {
    //   state.loading = true;
    //   state.error = "";
    // });
    // builder.addCase(createInquiry.fulfilled, (state) => {
    //   state.loading = false;
    // });
    // builder.addCase(createInquiry.rejected, (state, action) => {
    //   state.loading = false;
    //   state.error = action.error.message || "Something went wrong";
    // });

    // builder.addCase(updateInquiry.pending, (state) => {
    //   state.loading = true;
    //   state.error = "";
    // });
    // builder.addCase(updateInquiry.fulfilled, (state) => {
    //   state.loading = false;
    // });
    // builder.addCase(updateInquiry.rejected, (state, action) => {
    //   state.loading = false;
    //   state.error = action.error.message || "Something went wrong";
    // });

    builder.addCase(getInquiryByID.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(getInquiryByID.fulfilled, (state, action: any) => {
      state.loading = false;
      state.InquiryDetails = action.payload;
    });
    builder.addCase(getInquiryByID.rejected, (state, action) => {
      state.loading = false;
      state.InquiryDetails = initialState.InquiryDetails;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(getFollowupsByInquiryID.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(getFollowupsByInquiryID.fulfilled, (state, action: any) => {
      state.loading = false;
      state.InquiryFollowupList = action.payload;
    });
    builder.addCase(getFollowupsByInquiryID.rejected, (state, action) => {
      state.loading = false;
      state.InquiryFollowupList = initialState.InquiryFollowupList;
      state.error = action.error.message || "Something went wrong";
    });

    builder.addCase(deleteInquiry.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(deleteInquiry.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(deleteInquiry.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });

    builder.addCase(assignInquiryToUser.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(assignInquiryToUser.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(assignInquiryToUser.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });

    builder.addCase(createPackageInquiry.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(createPackageInquiry.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(createPackageInquiry.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });

    builder.addCase(updatePackageInquiry.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(updatePackageInquiry.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(updatePackageInquiry.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });

    builder.addCase(getPackageInquiryByID.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(getPackageInquiryByID.fulfilled, (state, action: any) => {
      state.loading = false;
      state.InquiryPackageDetails = action.payload;
    });
    builder.addCase(getPackageInquiryByID.rejected, (state, action) => {
      state.loading = false;
      state.InquiryPackageDetails = initialState.InquiryPackageDetails;
      state.error = action.error.message || "Something went wrong";
    });

    builder.addCase(createFlightInquiry.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(createFlightInquiry.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(createFlightInquiry.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });

    builder.addCase(updateFlightInquiry.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(updateFlightInquiry.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(updateFlightInquiry.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });

    builder.addCase(getFlightInquiryByID.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(getFlightInquiryByID.fulfilled, (state, action: any) => {
      state.loading = false;
      state.InquiryFlightDetails = action.payload;
    });
    builder.addCase(getFlightInquiryByID.rejected, (state, action) => {
      state.loading = false;
      state.InquiryFlightDetails = initialState.InquiryFlightDetails;
      state.error = action.error.message || "Something went wrong";
    });

    builder.addCase(createVisaInquiry.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(createVisaInquiry.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(createVisaInquiry.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });

    builder.addCase(updateVisaInquiry.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(updateVisaInquiry.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(updateVisaInquiry.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });

    builder.addCase(getVisaInquiryByID.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(getVisaInquiryByID.fulfilled, (state, action: any) => {
      state.loading = false;
      state.InquiryVisaDetails = action.payload;
    });
    builder.addCase(getVisaInquiryByID.rejected, (state, action) => {
      state.loading = false;
      state.InquiryVisaDetails = initialState.InquiryVisaDetails;
      state.error = action.error.message || "Something went wrong";
    });

    builder.addCase(createHotelInquiry.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(createHotelInquiry.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(createHotelInquiry.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });

    builder.addCase(updateHotelInquiry.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(updateHotelInquiry.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(updateHotelInquiry.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });

    builder.addCase(getHotelInquiryByID.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(getHotelInquiryByID.fulfilled, (state, action: any) => {
      state.loading = false;
      state.InquiryHotelDetails = action.payload;
    });
    builder.addCase(getHotelInquiryByID.rejected, (state, action) => {
      state.loading = false;
      state.InquiryHotelDetails = initialState.InquiryHotelDetails;
      state.error = action.error.message || "Something went wrong";
    });

    builder.addCase(insertFollowUp.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(insertFollowUp.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(insertFollowUp.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });

    builder.addCase(updateFollowUpStatus.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(updateFollowUpStatus.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(updateFollowUpStatus.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });

    builder.addCase(updateInquiryStatus.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(updateInquiryStatus.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(updateInquiryStatus.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });

    builder.addCase(updateInquiryStageStatus.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(updateInquiryStageStatus.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(updateInquiryStageStatus.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(getInquiryAssignUserHistory.pending, (state) => {
      state.formLoading = true;
      state.error = "";
    });
    builder.addCase(
      getInquiryAssignUserHistory.fulfilled,
      (state, action: any) => {
        state.formLoading = false;
        state.InquiryAssignUserHistory = action.payload || [];
      },
    );
    builder.addCase(getInquiryAssignUserHistory.rejected, (state, action) => {
      state.formLoading = false;
      state.InquiryAssignUserHistory = initialState.InquiryAssignUserHistory;
      state.error = action.error.message || "Something went wrong";
    });
  },
});

export const {
  clearInquiryDetails,
  setactiveTabIndex,
  clearInquiryID,
  setInquiryID,
  clearTripID,
  setTripID,
  setInquiryStageID,
  clearInquiryStageID,
  setInquiryStageDetails,
  clearInquiryStageDetails,
  setInquiryStatus,
  clearInquiryStatus,
  setInquiryFilterDetails,
  clearInquiryFilterDetails,
  openCompleteFollowupDialog,
  closeCompleteFollowupDialog,
  clearInquiryList,
} = inquirySlice.actions;
export default inquirySlice.reducer;
